/**
 * RunningSimulationsPanel.jsx - Running simulations progress panel
 * Shows all currently running simulations with progress bars
 * Extracted from Simulations.jsx
 */
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { Activity, X } from 'lucide-react';

const RunningSimulationsPanel = ({ simulations, onStop }) => {
  const runningSimulations = simulations?.filter(s => s.status === 'running') || [];
  
  if (runningSimulations.length === 0) return null;
  
  return (
    <Card className="border-blue-200 bg-blue-50/30" data-testid="running-simulations-panel">
      <CardContent className="pt-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Activity className="w-5 h-5 text-blue-600 animate-pulse" />
            <span className="font-medium text-blue-900">
              {runningSimulations.length} Simulation{runningSimulations.length !== 1 ? 's' : ''} Running
            </span>
          </div>
          <Badge variant="outline" className="text-xs bg-blue-100 text-blue-700 border-blue-200 animate-pulse">
            In Progress
          </Badge>
        </div>
        <div className="space-y-3">
          {runningSimulations.map(sim => (
            <div key={sim.id} className="bg-white rounded-lg border border-blue-100 p-3" data-testid={`running-sim-${sim.id}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-slate-800 truncate max-w-[200px]">{sim.name}</span>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-blue-600 font-semibold">{sim.progress || 0}%</span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onStop(sim.id)}
                    className="h-6 px-2 text-red-500 hover:text-red-700 hover:bg-red-50"
                  >
                    <X className="w-3 h-3" />
                  </Button>
                </div>
              </div>
              <Progress value={sim.progress || 0} className="h-2" />
              <div className="flex items-center justify-between mt-1.5 text-[10px] text-slate-500">
                <span>Processing responses...</span>
                <span>{sim.total_responses || sim.sample_size || '—'} responses</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RunningSimulationsPanel;
